import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import WorkspaceNameInput from "./WorkspaceNameInput";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function Modal({
  title,
  placeholder,
  buttonText,
  visible,
  onSubmit,
  onClose,
}) {
  return (
    <Transition appear show={visible} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={() => null}
      >
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-creately-theme-black dark:bg-transparent transition-colors duration-150 bg-opacity-20" />
          </Transition.Child>
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-zinc-700 shadow-xl rounded-md">
              <div className="flex items-center justify-between">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 dark:text-creately-theme-skin"
                >
                  {title}
                </Dialog.Title>
                <button onClick={onClose}>
                  <XMarkIcon className="w-4 h-4" />
                </button>
              </div>
              <WorkspaceNameInput
                onSubmit={onSubmit}
                placeholder={placeholder}
                buttonText={buttonText}
              />
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
